<template>
  <div v-if="detailData">
    <div class="intro-x flex flex-col sm:flex-row items-center mt-8">
      <h2 class="text-lg font-medium mr-auto">{{detailData.title}}</h2>
    </div>

    <div class="detailsBody" v-html="detailData.content">
      <!-- <div class="detailHead">
        <span>100 米赛跑的时候你是没有时间去看你的对手的</span>
      </div>
      <div class="imgUrl-box">
        <img
          src="https://img.shipin520.com/photo/00006/08635-350-v1.jpg?imageView2/2/sharpen/1"
          alt=""
        />
      </div>
      <div class="font-box">
        <div>
          易次将面头强样按国会名光时十县容流状识而非达理离解江即高战红变报存与形感速器切周信志子七加边金说劳况。管切存成且但间易长身好严存法建产去而构身线准们复断水即却信次式近口断日给制以亲精制布合很机形光过十定本始。
        </div>
        <div>
          五党图格头设张支领制八位权场自还反法其多造向是认具资内列况实标空们。者究毛具七才连声现权自写照期越无色消例马半每化安适关须观他受外党划界不世清同二到红再持质并北平省看低心等。压易次将面头强样按国会名光时十县容流状识而非达理离解江即高战红变报存与形感速器切周信志子七加边金说劳况。管切存成且但间易长身好严存法建产去而构身线准们复断水即却信次式近口断日给制以亲精制布合很机形光过十定本始。五党图格头设张支领制八位权场自还反法其多造向。
        </div>
      </div>

      <div class="imgUrl-box">
        <img
          src="https://ss2.bdstatic.com/70cFvnSh_Q1YnxGkpoWK1HF6hhy/it/u=3111049137,3116259153&fm=26&gp=0.jpg"
          alt=""
        />
      </div>

      <div class="font-box">
        <div>
          易次将面头强样按国会名光时十县容流状识而非达理离解江即高战红变报存与形感速器切周信志子七加边金说劳况。管切存成且但间易长身好严存法建产去而构身线准们复断水即却信次式近口断日给制以亲精制布合很机形光过十定本始。
        </div>
        <div>
          五党图格头设张支领制八位权场自还反法其多造向是认具资内列况实标空们。者究毛具七才连声现权自写照期越无色消例马半每化安适关须观他受外党划界不世清同二到红再持质并北平省看低心等。压易次将面头强样按国会名光时十县容流状识而非达理离解江即高战红变报存与形感速器切周信志子七加边金说劳况。管切存成且但间易长身好严存法建产去而构身线准们复断水即却信次式近口断日给制以亲精制布合很机形光过十定本始。五党图格头设张支领制八位权场自还反法其多造向。
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import request from "../utils/request";

export default {
  data: function () {
    return {
      detailData: null,
    };
  },

  mounted: function () {
    let id = this.$router.history.current.query.id;

    request({
      url: "/api/message/detail/" + id,
    }).then((res) => {

        this.detailData = res.data

    
    });
  },
};
</script>

<style lang="scss" scoped>
.detailsBody {
  width: 769px;
  background: #ffffff;
  box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.03);
  opacity: 1;
  border-radius: 22px;
  padding-bottom: 80px;
  margin-top: 20px;
  .detailHead {
    height: 62px;
    line-height: 60px;
    box-sizing: border-box;
    border-bottom: 1px solid #e2e8f0;
    span {
      padding: 0 20px;
      color: #2d3748;
      font-size: 16px;
    }
  }
  .imgUrl-box {
    padding: 20px;
    width: 100%;
    box-sizing: border-box;
    img {
      margin: 0;
      width: 100%;
      vertical-align: middle;
    }
  }
  .font-box {
    width: 100%;
    box-sizing: border-box;
    padding: 0 20px;
    color: #2d3748;
    font-size: 14px;
    line-height: 28px;
    div {
      text-indent: 2em;
    }
  }
}

@media screen and (max-width: 600px) {
  .detailsBody .detailHead {
    height: 50px;
    line-height: 50px;
    span {
      font-size: 0.9rem !important;
      font-weight: bold;
      box-sizing: border-box;
      width: 100%;
      display: block;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
  .detailsBody {
    width: 100% !important;
    .font-box {
      font-size: 0.8rem;
    }
  }
}
</style>